export type { TagButtonProps } from './TagButton.types';
export { default } from './TagButton';
